var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var SecondaryToolbarTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 44px;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  font-size: 22px;\n  font-weight: 500;\n"], ["\n  height: 44px;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  font-size: 22px;\n  font-weight: 500;\n"])));
// tslint:disable-next-line: no-object-mutation
SecondaryToolbarTitle.displayName = 'SecondaryToolbarTitle';
export default SecondaryToolbarTitle;
var templateObject_1;
//# sourceMappingURL=SecondaryToolbarTitle.js.map